import agent from '../agent'
import {
  APP_LOAD,
  LOAD_BASE_COIN_ACCOUNT,
  REDIRECT,
  ACCOUNT_GO,
  COIN_TRANSACTION_GO,
  ASYNC_START,
  ASYNC_END,
  SOCKET_MESSAGE_TRANSACTION_CREATED,
  LOGOUT,
  LOGIN,
  LOGIN_PAGE_VERIFY_PIN_CODE,
  VERIFY_USER_PIN,
  CATEGORY_ADD,
  CATEGORY_UPDATE,
  CATEGORY_DELETE,
  PRODUCT_ADD,
  PRODUCT_UPDATE,
  PRODUCT_DELETE,
  TRANSACTIONS_LOADED,
  TRANSACTIONS_UNLOADED,
  PAY_LOADED,
  CART_LOADED,
  LOGIN_GO,
  REGISTER_GO,
  REGISTER
} from '../constants/actionTypes';

import {
  BASE_COIN_SYMBOL,
  APP_NAME,
  ORG_NAME
} from '../constants/config'
import { parse } from 'url';


const defaultState = {
  appName: APP_NAME,
  orgName: ORG_NAME,
  token: null,
  viewChangeCounter: 0,
  recentTransactions: [],
  recentTransactionPageSize: 30,
  transactionsPage: [],
  newTransactionAdded: false
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case APP_LOAD:
      {
        return {
          ...state,
          token: action.token || null,
          appLoaded: true,
          currentUser: action.payload ? action.payload.user : null,
          redirectTo: (action.payload && action.payload.user) ? null : '/login',
          // recentTransactions: action.payload != null && action.payload.transactions != null
          // ? action.payload.transactions.transactions: null
        }
      }
    case LOAD_BASE_COIN_ACCOUNT:
      return {
        ...state,
        token: action.token || null,
        baseAccount: action.payload ? action.payload.account : null,
        errors: action.error ? action.payload.error : null
      }
    case REDIRECT:
      return { ...state, redirectTo: null }
    case ACCOUNT_GO:
      return { ...state, redirectTo: '/account/' + action.payload }
    case COIN_TRANSACTION_GO:
      return { ...state, redirectTo: '/txn/' + action.payload }
    case SOCKET_MESSAGE_TRANSACTION_CREATED:
      let recentTransaction = [JSON.parse(action.payload)]
      state.recentTransactions.splice(-1, 1) // remove
      return {
        ...state,
        recentTransactions: recentTransaction.concat(state.recentTransactions),
        newTransactionAdded: true
      }
    case LOGIN_GO:
      return { ...state, redirectTo: '/login' }
    case REGISTER_GO:
      return { ...state, redirectTo: '/register' }
    case REGISTER:
      return {
        ...state,
        redirectTo: action.error ? null : '/registersuccess',
      }
    case LOGOUT:
      return { ...state, redirectTo: '/', token: null, currentUser: null };
    case LOGIN:
      let login_redirect = null
      if (action.payload && action.payload.user) {
        if (action.payload.user.pin_enabled) {
          login_redirect = 'verifypin'
        } else if (action.payload.user.token) {
          login_redirect = '/'
        } else {
          login_redirect = 'Verification'
        }
      }
      return {
        ...state,
        token: action.error ? null : action.payload.user ? action.payload.user.token : null,
        currentUser: action.error ? null : action.payload.user ? action.payload.user : null,
        redirectTo: action.error ? null :login_redirect,
      }
    case LOGIN_PAGE_VERIFY_PIN_CODE:
      return {
        ...state,
        token: action.error ? null : action.payload.user.token,
        currentUser: action.error ? null : action.payload.user,
        redirectTo: action.error ? null : '/',
      }
    case VERIFY_USER_PIN:
      return {
        ...state,
        currentUser: action.error ? state.currentUser : action.payload.user,
        redirectTo: action.error ? null : '/',
        errors: action.error ? action.payload.error : null,
      }
    case CATEGORY_ADD:
    case CATEGORY_UPDATE:
    case CATEGORY_DELETE:
      return { ...state, redirectTo: action.error ? null : '/categories/manage' }
    case PRODUCT_ADD:
    case PRODUCT_UPDATE:
    case PRODUCT_DELETE:
      return { ...state, redirectTo: action.error ? null : '/products/manage' }
    // put these at the bottom
    case PRODUCT_UPDATE:
    case PRODUCT_DELETE:
      return { ...state, redirectTo: action.error ? null : '/products/manage' }
    // put these at the bottom
    case TRANSACTIONS_LOADED:
    case PAY_LOADED:
    case CART_LOADED:
      return {
        ...state,
        recentTransactions: action.payload != null && action.payload.transactions != null
          ? action.payload.transactions.transactions : null,
        newTransactionAdded: false
      }
    case TRANSACTIONS_UNLOADED:
      return {
        ...state,
        newTransactionAdded: false
      }
    case ASYNC_END:
      return { ...state, inProgress: false }
    default:
      return state;
  }
};
